/**
 * Created by jonas on 2020-11-05.
 */
import {OutsourcedSound} from "../sound/OutsourcedSound";


export interface WinSoundConfig {
    start:string;
    sound:string;
    end:string;
}

export class WinConfigBased {
    name:string;
    fromRatio:number;
    toRatio:number;
    duration:number;
    sound:WinSoundConfig;
}

export class WinConfigUtilBased {

    public static TINY = {
        name: "TINY",
        fromRatio: 0,
        toRatio: 1,
        duration: 0,
        sound: {
            start : OutsourcedSound.WIN_TINY_START,
            sound : OutsourcedSound.WIN_TINY,
            end   : OutsourcedSound.WIN_TINY_END
        }
    }
    public static SMALL = {
        name: "SMALL",
        fromRatio: 1,
        toRatio: 3,
        duration: 0,
        sound: {
            start : OutsourcedSound.WIN_SMALL_START,
            sound : OutsourcedSound.WIN_SMALL,
            end   : OutsourcedSound.WIN_SMALL_END
        }
    }
    public static MEDIUM = {
        name: "MEDIUM",
        fromRatio: 3,
        toRatio: 5,
        duration: 0.5,
        sound: {
            start : OutsourcedSound.WIN_MEDIUM_START,
            sound : OutsourcedSound.WIN_MEDIUM,
            end   : OutsourcedSound.WIN_MEDIUM_END
        }
    }
    public static LARGE = {
        name: "LARGE",
        fromRatio: 5,
        toRatio: 15,
        duration: 0.75,
        sound: {
            start : OutsourcedSound.WIN_LARGE_START,
            sound : OutsourcedSound.WIN_LARGE,
            end   : OutsourcedSound.WIN_LARGE_END
        }
    }

    //25x, 50x, 100x, 250x, 250x+
    // big wins have empty sound configs because big win sounds are handled in a different way than regular wins
    public static BIG_1 = {
        name: "BIG_1",
        fromRatio: 0,
        toRatio: 25,
        duration: 1.714,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_2 = {
        name: "BIG_2",
        fromRatio: 25,
        toRatio: 50,
        duration: 3.429,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_3 = {
        name: "BIG_3",
        fromRatio: 50,
        toRatio: 100,
        duration: 3.429,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_4 = {
        name: "BIG_4",
        fromRatio: 100,
        toRatio: 250,
        duration: 1.714,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_5 = {
        name: "BIG_5",
        fromRatio: 250,
        toRatio: Number.MAX_VALUE,
        duration: 1.714,
        sound: {start: "", sound: "", end: ""}
    }

    public static BIG_1_FEATURE_BUY = {
        name: "BIG_1",
        fromRatio: 0,
        toRatio: 2,
        duration: 1.614,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_2_FEATURE_BUY = {
        name: "BIG_2",
        fromRatio: 2,
        toRatio: 4,
        duration: 3.429,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_3_FEATURE_BUY = {
        name: "BIG_3",
        fromRatio: 4,
        toRatio: 7,
        duration: 3.429,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_4_FEATURE_BUY = {
        name: "BIG_4",
        fromRatio: 7,
        toRatio: 10,
        duration: 1.714,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_5_FEATURE_BUY = {
        name: "BIG_5",
        fromRatio: 10,
        toRatio: Number.MAX_VALUE,
        duration: 1.714,
        sound: {start: "", sound: "", end: ""}
    }

    public static normalLevels:WinConfigBased[] = [
        WinConfigUtilBased.TINY,
        WinConfigUtilBased.SMALL,
        WinConfigUtilBased.MEDIUM,
        WinConfigUtilBased.LARGE,
    ];

    public static bigLevels:WinConfigBased[] = [
        WinConfigUtilBased.BIG_1,
        WinConfigUtilBased.BIG_2,
        WinConfigUtilBased.BIG_3,
        WinConfigUtilBased.BIG_4,
        WinConfigUtilBased.BIG_5
    ];

    public static bigLevelsFeatureBuy:WinConfigBased[] = [
        WinConfigUtilBased.BIG_1_FEATURE_BUY,
        WinConfigUtilBased.BIG_2_FEATURE_BUY,
        WinConfigUtilBased.BIG_3_FEATURE_BUY,
        WinConfigUtilBased.BIG_4_FEATURE_BUY,
        WinConfigUtilBased.BIG_5_FEATURE_BUY
    ];
}

